import React from 'react';
import { Popup as PopupReactLealet, useMap } from 'react-leaflet';
import { FuelInteractiveIcon } from '@frete.com/fuel-react';
import { FuelFlex } from '@frete.com/fuel-station-react';
import { MarkerInterface } from '../../MapContainerType';
import Location from './Location';
import Actions from './Actions';
import Occurrence from './Occurrence';

function Popup(marker: MarkerInterface) {
  const map = useMap();
  const { action, journeyId, occurrence } = marker;

  return (
    <PopupReactLealet
      offset={[0, -38]}
      closeButton={false}
      minWidth={280}
      maxWidth={280}
    >
      <FuelFlex defaultProps={{ gap: 'km2' }}>
        <Location {...marker} />
        <FuelInteractiveIcon
          data-testid="popupCloseBtn"
          icon="close"
          size="small"
          onClick={() => {
            map.closePopup();
            window.dispatchEvent(
              new CustomEvent('closePopupMarker', {
                detail: journeyId,
              }),
            );
          }}
        />
      </FuelFlex>
      <Occurrence {...occurrence} journeyId={journeyId} />
      <Actions {...action} />
    </PopupReactLealet>
  );
}

export default Popup;
